import { withSubComponent } from '@magnetic/higher-order-components';
import { Block } from './block/index.js';
import { Inline } from './inline/index.js';
import './inline/style.css.js';
import '@magnetic/theme';

const Code = withSubComponent(Inline, {
  Inline,
  Block
});
Code.displayName = "Code.Inline";

export { Code };
//# sourceMappingURL=index.js.map
